import styled from "styled-components"
import { colors } from "../../../../lib/colors"

interface liveScore_props {
  removeComponents: boolean
  popup: boolean
}

export const LiveScoresContainer = styled.div<liveScore_props>`
  background: rgba(11, 10, 13, 0.8);
  opacity: ${({ removeComponents }) => (removeComponents ? 0 : 1)};
  transition: opacity 3s;
  padding: 16px;
  border-radius: 4px;
  display: ${({ popup }) => (popup ? "none" : "block")};
  margin: 0 18px;
  height: 321px;
  @media only screen and (min-width: 768px) {
    margin: 18px;
  }
  @media (min-width: 1024px) {
    width: 30%;
    max-width: 400px;
    min-width: 300px;
    margin: 0;
    height: auto;
    overflow: hidden;
  }
`
